import { styled } from '@mui/material/styles';

const Box = styled('div')``;

export default Box;
